
import state from './activitiesState.js'
import * as mutations from './activitiesMutations.js'
import * as actions from './activitiesActions.js'
import * as getters from './activitiesGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}